module.exports = __webpack_public_path__ + "static/media/accessDeniedImage.8e8b797a.png";